module.exports = __webpack_public_path__ + "static/media/konf-room4.8f4a918e.jpg";